"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInput = void 0;
const react_1 = __importStar(require("react"));
const utils_1 = require("./utils");
const SingleSelectMenu_1 = require("../Menus/SingleSelectMenu");
const BaseComponents_1 = require("./BaseComponents");
const SelectInput = (props) => {
    const { width, value, options, label, onOptionSelected, clean = false, hideIcon = false, disabled = false, sectionOptions, hasSections = false, displayValue, renderOption, selectedOptionComparator, } = props;
    const [isMenuOpen, setMenuOpen] = (0, react_1.useState)(false);
    const iconToRender = () => {
        if (clean && value && value.optionName) {
            return (react_1.default.createElement(BaseComponents_1.CleanIcon, { onClean: (event) => {
                    onOptionSelected({ optionName: '' });
                    event.stopPropagation();
                } }));
        }
        return react_1.default.createElement(BaseComponents_1.SelectIcon, { variant: isMenuOpen ? 'up' : 'down' });
    };
    return (react_1.default.createElement(SingleSelectMenu_1.SingleSelectMenu, { width: (0, utils_1.getWidthValue)(width), VisualElement: react_1.default.createElement(BaseComponents_1.SelectContainer, Object.assign({}, props, { isActive: isMenuOpen, className: "inputContainer" }),
            react_1.default.createElement(BaseComponents_1.SelectValueLabel, { value: displayValue || (value === null || value === void 0 ? void 0 : value.optionName), label: label }),
            !hideIcon && iconToRender()), onOptionSelected: onOptionSelected, selectedOption: value, menuOptions: options !== null && options !== void 0 ? options : [], sectionOptions: sectionOptions, hasSections: hasSections, menuLocation: "below", setMenuOpen: setMenuOpen, selectedOptionComparator: selectedOptionComparator, disabled: disabled || hideIcon || (clean && (value === null || value === void 0 ? void 0 : value.optionName) !== ''), renderOption: renderOption }));
};
exports.SelectInput = SelectInput;
exports.default = exports.SelectInput;
//# sourceMappingURL=SelectInput.js.map